import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components'

import { meta } from '../../index.js'

export default class toll extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'Toll')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study"> 

				    <div className="container">

				        <div className="title">

				            <a href="https://toll.com.au" target="_blank"><img src="/images/new/logos/team-global-express.svg"/></a>
				            <h3>Asia-Pacific with a global reach</h3>
				            {/* <p>Team Global Express (formerly TOLL), is one of the largest logistics companies in the Asia Pacific. While Team Global Express pride themselves on ensuring parcels are delivered in record time, customers are not always home to accept delivery. With parcel security a top priority, deliveries were increasingly redirected to depots to await collection or redelivery. Team Global Express needed a way to turn this commitment to security into increased customer convenience.</p> */}
							<p>Team Global Express (formerly Toll Global Express) is driven by our purpose of making sure life never stops.  We pride ourselves on delivering for our customers, even when they aren’t home.  That’s why we have partnered with blueshyft’s national network of alternative delivery locations, giving our customers the flexibility to collect their parcel when it suits them.</p>	
				        </div>

						<div className="block">
						
							<h4>Finding a streamlined solution</h4>
							<p>With considerable overheads as a result of failed and re-deliveries, Team Global Express were in need of a solution that would allow customers to collect parcels from a nearby pick-up point following missed deliveries.</p>
						
						</div>

				        <div className="block">

				            <h4>From redirect to reinvent</h4>
				            <p>With a nation-wide network, a state-of-the-art scalable platform and extensive experience in last mile logistics, blueshyft offered the perfect means to turn Team Global Express’ challenges into an opportunity. Maximising strategic benefit, blueshyft crafted a solution to:</p>

				            <div className="features">

				                <div className="feature">
				                    <img src="/images/new/icons/cross-blue.svg"/>
				                    <p>Create a process for failed delivery collection</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/arrow-blue.svg"/>
				                    <p>Integrate with Team Global Express to allow for direct deliveries</p>
				                </div>
				                <div className="feature">
				                    <img src="/images/new/icons/returns-blue.svg"/>
				                    <p>Roll out a fast and easy method for customer-initiated parcel returns</p>
				                </div>

				            </div>
				    
				        </div>

				        <div className="block">

				            <h4>Delivering on time, every time</h4>
				            <p>Mixing previous experience with a unique solution, blueshyft were able to offer Team Global Express’ customers a no-fuss, streamlined service to take the hassle out of parcel pick-ups & drop-offs. The partnership increased efficiencies and reduced operational overheads, while boosting efficiency and customer satisfaction. The result? Customers are now able to:</p>
				            <p>•  Collect their parcels from their local blueshyft agent - by redirecting failed home deliveries to blueshyft locations instead of depots, Team Global Express have fewer re-deliveries and customers receive a more personalised service that works around their schedules</p>
				            <p>•  Nominate their local blueshyft agent for direct delivery - if a customer knows they won't be home to receive a package, they can select their local blueshyft store as the delivery address and collect at their convenience</p>
				            <p>•  Return select purchases through the blueshyft network - using the blueshyft POS app, customers are able to book in their purchase for return quickly and easily</p>

				        </div>

				        <div className="highlight">

				            <p>With the integration of blueshyft’s platform, Team Global Express customers are now able to collect parcels 
				                from their local newsagent in their own time, and sidestep the hassle of redeliveries. 
				                The blueshyft platform’s new services have reduced failed deliveries and boosted 
				                Team Global Express’ customer convenience, satisfaction and retention!</p>
				    
				        </div>

				    </div>

				</section>

				<MoreCaseStudies cases={['lb', 'goget', 'news']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/toll/index.js